// DO NOT EDIT -- generated from fs/services/search-settings/namedelements.proto

import * as pagination from '../../shared/pagination';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace NamedElements {

  export const ArchiveNamedElementEndpoint = "/grpc/search_settings.NamedElements/ArchiveNamedElement";
  /**
   * Archive an existing named element for an org.
   * Once archived, the named element cannot be modified and will not show up in GetAllNamedElements unless explicitly requested.
   */
  export function ArchiveNamedElement(sender: (req: ArchiveNamedElementRequest, endpoint: string) => Promise<ArchiveNamedElementResponse>, req: ArchiveNamedElementRequest): { promise: () => Promise<ArchiveNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveNamedElementEndpoint),
      endpoint: ArchiveNamedElementEndpoint
    };
  }

  export const ArchiveMultiNamedElementsEndpoint = "/grpc/search_settings.NamedElements/ArchiveMultiNamedElements";
  export function ArchiveMultiNamedElements(sender: (req: ArchiveMultiNamedElementsRequest, endpoint: string) => Promise<ArchiveMultiNamedElementsResponse>, req: ArchiveMultiNamedElementsRequest): { promise: () => Promise<ArchiveMultiNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiNamedElementsEndpoint),
      endpoint: ArchiveMultiNamedElementsEndpoint
    };
  }

  export const UnarchiveNamedElementEndpoint = "/grpc/search_settings.NamedElements/UnarchiveNamedElement";
  /**
   * Unarchives an existing named element for an org.
   * Once unarchived, the named element can continue to be modified and will show up in GetAllNamedElements.
   */
  export function UnarchiveNamedElement(sender: (req: UnarchiveNamedElementRequest, endpoint: string) => Promise<UnarchiveNamedElementResponse>, req: UnarchiveNamedElementRequest): { promise: () => Promise<UnarchiveNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveNamedElementEndpoint),
      endpoint: UnarchiveNamedElementEndpoint
    };
  }

  export const UnarchiveMultiNamedElementsEndpoint = "/grpc/search_settings.NamedElements/UnarchiveMultiNamedElements";
  export function UnarchiveMultiNamedElements(sender: (req: UnarchiveMultiNamedElementsRequest, endpoint: string) => Promise<UnarchiveMultiNamedElementsResponse>, req: UnarchiveMultiNamedElementsRequest): { promise: () => Promise<UnarchiveMultiNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveMultiNamedElementsEndpoint),
      endpoint: UnarchiveMultiNamedElementsEndpoint
    };
  }

  export const GetAllNamedElementsEndpoint = "/grpc/search_settings.NamedElements/GetAllNamedElements";
  /**
   * Get all current non-archived named elements for an org.
   * If desired, archived named elements can also be retrieved with the explicit request flag.
   */
  export function GetAllNamedElements(sender: (req: GetAllNamedElementsRequest, endpoint: string) => Promise<GetAllNamedElementsResponse>, req: GetAllNamedElementsRequest): { promise: () => Promise<GetAllNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllNamedElementsEndpoint),
      endpoint: GetAllNamedElementsEndpoint
    };
  }

  export const GetAllSuggestedElementsEndpoint = "/grpc/search_settings.NamedElements/GetAllSuggestedElements";
  /** Returns pending elements, as well as expired and rejected elements if requested. Currently only used by llm-tool */
  export function GetAllSuggestedElements(sender: (req: GetAllSuggestedElementsRequest, endpoint: string) => Promise<GetAllSuggestedElementsResponse>, req: GetAllSuggestedElementsRequest): { promise: () => Promise<GetAllSuggestedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSuggestedElementsEndpoint),
      endpoint: GetAllSuggestedElementsEndpoint
    };
  }

  export const GetNamedElementEndpoint = "/grpc/search_settings.NamedElements/GetNamedElement";
  /** Get a specific named element, either current or past version. */
  export function GetNamedElement(sender: (req: GetNamedElementRequest, endpoint: string) => Promise<GetNamedElementResponse>, req: GetNamedElementRequest): { promise: () => Promise<GetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementEndpoint),
      endpoint: GetNamedElementEndpoint
    };
  }

  export const BatchGetNamedElementsEndpoint = "/grpc/search_settings.NamedElements/BatchGetNamedElements";
  /** Get a specific set of named elements, either current or past versions. */
  export function BatchGetNamedElements(sender: (req: BatchGetNamedElementRequest, endpoint: string) => Promise<BatchGetNamedElementResponse>, req: BatchGetNamedElementRequest): { promise: () => Promise<BatchGetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetNamedElementsEndpoint),
      endpoint: BatchGetNamedElementsEndpoint
    };
  }

  export const SetNamedElementEndpoint = "/grpc/search_settings.NamedElements/SetNamedElement";
  /** Add a new named element or update an existing named element. */
  export function SetNamedElement(sender: (req: SetNamedElementRequest, endpoint: string) => Promise<SetNamedElementResponse>, req: SetNamedElementRequest): { promise: () => Promise<SetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetNamedElementEndpoint),
      endpoint: SetNamedElementEndpoint
    };
  }

  export const ListNamedElementsEndpoint = "/grpc/search_settings.NamedElements/ListNamedElements";
  /**
   * Lists named elements, returning a batch of named elements and a pagination token.
   * A sane default limit per batch is enforced if not limit is provided.
   * Results are ordered by last modified date.
   */
  export function ListNamedElements(sender: (req: ListNamedElementsRequest, endpoint: string) => Promise<ListNamedElementsResponse>, req: ListNamedElementsRequest): { promise: () => Promise<ListNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListNamedElementsEndpoint),
      endpoint: ListNamedElementsEndpoint
    };
  }

  export const CreateApiElementsEndpoint = "/grpc/search_settings.NamedElements/CreateApiElements";
  export function CreateApiElements(sender: (req: CreateApiElementsRequest, endpoint: string) => Promise<CreateApiElementsResponse>, req: CreateApiElementsRequest): { promise: () => Promise<CreateApiElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateApiElementsEndpoint),
      endpoint: CreateApiElementsEndpoint
    };
  }

  export const SetSuggestedElementEndpoint = "/grpc/search_settings.NamedElements/SetSuggestedElement";
  /** SetSuggestedElement is called by LLM-tool to store a learned element */
  export function SetSuggestedElement(sender: (req: SetSuggestedElementRequest, endpoint: string) => Promise<SetSuggestedElementResponse>, req: SetSuggestedElementRequest): { promise: () => Promise<SetSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSuggestedElementEndpoint),
      endpoint: SetSuggestedElementEndpoint
    };
  }

  export const GetSuggestedElementEndpoint = "/grpc/search_settings.NamedElements/GetSuggestedElement";
  export function GetSuggestedElement(sender: (req: GetSuggestedElementRequest, endpoint: string) => Promise<GetSuggestedElementResponse>, req: GetSuggestedElementRequest): { promise: () => Promise<GetSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSuggestedElementEndpoint),
      endpoint: GetSuggestedElementEndpoint
    };
  }
}

export namespace NamedElementsPublic {

  export const ArchiveNamedElementEndpoint = "/grpc/search_settings.NamedElementsPublic/ArchiveNamedElement";
  /**
   * Archive an existing named element for an org.
   * Once archived, the named element cannot be modified and will not show up in GetAllNamedElements unless explicitly requested.
   */
  export function ArchiveNamedElement(sender: (req: ArchiveNamedElementRequest, endpoint: string) => Promise<ArchiveNamedElementResponse>, req: ArchiveNamedElementRequest): { promise: () => Promise<ArchiveNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveNamedElementEndpoint),
      endpoint: ArchiveNamedElementEndpoint
    };
  }

  export const UnarchiveNamedElementEndpoint = "/grpc/search_settings.NamedElementsPublic/UnarchiveNamedElement";
  /**
   * Unarchives an existing named element for an org.
   * Once unarchived, the named element can continue to be modified and will show up in GetAllNamedElements.
   */
  export function UnarchiveNamedElement(sender: (req: UnarchiveNamedElementRequest, endpoint: string) => Promise<UnarchiveNamedElementResponse>, req: UnarchiveNamedElementRequest): { promise: () => Promise<UnarchiveNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveNamedElementEndpoint),
      endpoint: UnarchiveNamedElementEndpoint
    };
  }

  export const GetAllNamedElementsEndpoint = "/grpc/search_settings.NamedElementsPublic/GetAllNamedElements";
  /**
   * Get all current non-archived named elements for an org.
   * If desired, archived named elements can also be retrieved with the explicit request flag.
   */
  export function GetAllNamedElements(sender: (req: GetAllNamedElementsRequest, endpoint: string) => Promise<GetAllNamedElementsResponse>, req: GetAllNamedElementsRequest): { promise: () => Promise<GetAllNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllNamedElementsEndpoint),
      endpoint: GetAllNamedElementsEndpoint
    };
  }

  export const GetNamedElementEndpoint = "/grpc/search_settings.NamedElementsPublic/GetNamedElement";
  /** Get a specific named element, either current or past version. */
  export function GetNamedElement(sender: (req: GetNamedElementRequest, endpoint: string) => Promise<GetNamedElementResponse>, req: GetNamedElementRequest): { promise: () => Promise<GetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementEndpoint),
      endpoint: GetNamedElementEndpoint
    };
  }

  export const SetNamedElementEndpoint = "/grpc/search_settings.NamedElementsPublic/SetNamedElement";
  /** Add a new named element or update an existing named element. */
  export function SetNamedElement(sender: (req: SetNamedElementRequest, endpoint: string) => Promise<SetNamedElementResponse>, req: SetNamedElementRequest): { promise: () => Promise<SetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetNamedElementEndpoint),
      endpoint: SetNamedElementEndpoint
    };
  }
}

export interface ArchiveNamedElementRequest {
  orgId: string;
  namedElementId: string;
}

export interface ArchiveNamedElementResponse {
  namedElement: NamedElementRecord | null;
}

export interface ArchiveMultiNamedElementsRequest {
  orgId: string;
  namedElementIds: string[];
}

export interface ArchiveMultiNamedElementsResponse {
  namedElements: NamedElementRecord[];
}

export interface UnarchiveNamedElementRequest {
  orgId: string;
  namedElementId: string;
}

export interface UnarchiveMultiNamedElementsRequest {
  orgId: string;
  namedElementIds: string[];
}

export interface UnarchiveMultiNamedElementsResponse {
  namedElements: NamedElementRecord[];
}

export interface UnarchiveNamedElementResponse {
  namedElement: NamedElementRecord | null;
}

export interface GetAllNamedElementsRequest {
  orgId: string;
  /** If true, archived named elements will also be returned. */
  includeArchived: boolean;
  /** If true, the response will return a mapping of api name -> id for all api identified named elements, regardless of archived status. */
  includeAllIdsByApiName: boolean;
  includeSuggested: boolean;
}

export interface GetAllNamedElementsResponse {
  /** The list of named elements matching the request parameters. */
  namedElements: NamedElementRecord[];
  /** Suggested elements that are not yet approved, only provided if requested. If requesting archived, this includes rejected suggestions. */
  pendingSuggestedElements: NamedElementRecord[];
  /** The limit of active elements. If length of active (i.e. non archived) elements are at or over limit, new elements will not be allowed. */
  activeLimit: number;
  /**
   * The exhaustive mapping of named element ids by api name, regardless of archived status.
   * This field is only provided when requested.
   */
  idsByApiName: { [key: string]: string };
}

export interface GetAllSuggestedElementsRequest {
  orgId: string;
  /** If true, rejected and expired elements will be returned */
  includeArchived: boolean;
}

export interface GetAllSuggestedElementsResponse {
  /** Suggested elements that are not yet approved. If requesting archived, this includes rejected suggestions. */
  suggestedElements: NamedElementRecord[];
}

export interface GetNamedElementRequest {
  /** required */
  orgId: string;
  /** required */
  namedElementId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
  /** if true, will include suggested elements in the response (if a suggested id is supplied) */
  includeSuggested: boolean;
}

export interface GetNamedElementResponse {
  versions: NamedElementRecord[];
}

export interface BatchGetNamedElementRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetNamedElementRequest.Identifier[];
  /** left for reference, only unset / 1 is supported right now */
  limit: number;
  /** if true, will include suggested elements in the response (if a suggested id is supplied) */
  includeSuggested: boolean;
}

export namespace BatchGetNamedElementRequest {
  export interface Identifier {
    /** required */
    namedElementId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned. */
    version: protobuf.int64;
  }
}

export interface BatchGetNamedElementResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found named elements will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetNamedElementResponse.Result[];
}

export namespace BatchGetNamedElementResponse {
  export interface Result {
    identifier: BatchGetNamedElementRequest.Identifier | null;
    versions: NamedElementRecord[];
  }
}

export interface ListNamedElementsRequest {
  orgId: string;
  pageInfo: pagination.PageInfoRequest | null;
  /** If non-zero, filters the response to just those modified since */
  modifiedSince: protobuf.timestamp | null;
  includeArchived: boolean;
}

export interface ListNamedElementsResponse {
  elements: NamedElementRecord[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface SetNamedElementRequest {
  orgId: string;
  /**
   * Named element to be created or updated.
   * If the id field is not set, an id will be generated and a named element will be stored.
   * If an id field is set, an existing named element must be in place to perform the update.
   */
  namedElement: NamedElement | null;
  /**
   * If set, dedupes create requests containing the same idempotence key.
   * If idempotence key has already been handled, the existing entity will be returned instead of creating a new entity.
   * The idempotence key is only respected on create requests that let the server generate the entity id.
   * Note: This is best effort. Idempotence keys are kept around for three days but may be garbage collected sooner.
   */
  idempotenceKey: string;
}

export interface SetNamedElementResponse {
  namedElement: NamedElementRecord | null;
}

export interface CreateApiElementsRequest {
  orgId: string;
  apiElementNames: string[];
}

export interface CreationError {
  apiName: string;
  reason: CreationError.Reason;
}

export namespace CreationError {
  export enum Reason {
    REASON_INVALID = 0,
    /** The number of active Elements has surpassed the limit. maps to cookerr.REASON_VARS_ELEM_NAME_CARDINALITY */
    REASON_EXCEEDED_LIMIT = 1,
    /** * maps to REASON_VARS_INVALID_NAME  */
    REASON_INVALID_NAME = 2
  }
}

export interface CreateApiElementsResponse {
  elements: NamedElementRecord[];
  creationErrors: CreationError[];
}

export interface NamedElement {
  id: string;
  name: string;
  description: string;
  apiName: string;
  /** Replacement for selectors for platform selector support */
  platformSelectors: segment.PlatformSelector[];
  suggestion: Suggestion | null;
}

export interface NamedElementRecord {
  namedElement: NamedElement | null;
  metadata: protoauditstore.AuditMetadata | null;
  /** empty if not created using idempotence key */
  createIdempotenceKey: string;
}

export interface Suggestion {
  id: string;
  traceId: string;
  status: Suggestion.Status;
  name: string;
  description: string;
  platformSelectors: segment.PlatformSelector[];
  /** The spec slug */
  spec: string;
  /** Optional, potential elements that the suggestion could be merged into */
  existingElements: IdAndName[];
  /** Fields related to the suggestion generation request. The selector generated from the initiator */
  reqInitialCandidateSelector: string;
  /** Initiator method to generate the suggestions */
  reqInitiator: string;
  /** Trim method of the suggestion */
  reqSelectorTrim: string;
  /** If true, the suggestion with be auto watched */
  autoWatch: boolean;
}

export namespace Suggestion {
  export enum Status {
    STATUS_UNSET = 0,
    STATUS_PENDING = 1,
    STATUS_APPROVED = 2,
    STATUS_AUTO_APPROVED = 6,
    STATUS_FS_REJECTED = 3,
    STATUS_USER_REJECTED = 4,
    STATUS_EXPIRED = 5
  }
}

export interface IdAndName {
  id: string;
  name: string;
}

export interface SuggestionRecord {
  suggestion: Suggestion | null;
  metadata: protoauditstore.AuditMetadata | null;
}

export interface SetSuggestedElementRequest {
  orgId: string;
  suggestion: Suggestion | null;
}

export interface SetSuggestedElementResponse {
  suggestion: SuggestionRecord | null;
}

export interface GetSuggestedElementRequest {
  orgId: string;
  elementId: string;
}

export interface GetSuggestedElementResponse {
  suggestion: SuggestionRecord | null;
}
